import { render } from "./WysiwygEditor.vue?vue&type=template&id=4e8e2a05&scoped=true"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js"

import "./WysiwygEditor.vue?vue&type=style&index=0&id=4e8e2a05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8e2a05"]])

export default __exports__